import debug from 'debug';

const APP_NAME = 'sipcaller';

export default class Logger
{
	constructor(prefix)
	{
		if (prefix)
		{
			this._debug = debug(`${APP_NAME}:${prefix}`);
			this._warn = debug(`${APP_NAME}:WARN:${prefix}`);
			this._error = debug(`${APP_NAME}:ERROR:${prefix}`);
		}
		else
		{
			this._debug = debug(APP_NAME);
			this._warn = debug(`${APP_NAME}:WARN`);
			this._error = debug(`${APP_NAME}:ERROR`);
		}

		/* eslint-disable no-console */
		this._debug.log = console.info.bind(console);
		this._warn.log = console.warn.bind(console);
		this._error.log = console.error.bind(console);
		/* eslint-enable no-console */
	}

	get debug()
	{
		return this._debug;
	}

	get warn()
	{
		return this._warn;
	}

	get error()
	{
		return this._error;
	}
}

export const debugSipMessage = (direction, message) => {
	console.group(`SIP ${direction.toUpperCase()}`);

	try {
		// Attempt to parse and pretty-print the SIP message for better readability
		const lines = message.split('\r\n');

		// Process first line (Request/Status line)
		console.log('%c' + lines[0], 'font-weight: bold; color: blue;');

		// Extract and log headers
		let headersPrinted = false;
		let bodyStartIndex = lines.findIndex(line => line === '');

		if (bodyStartIndex > 0) {
			console.group('Headers:');
			for (let i = 1; i < bodyStartIndex; i++) {
				const header = lines[i];
				// Color-code important headers
				if (header.startsWith('Call-ID:')) {
					console.log('%c' + header, 'color: #9900cc; font-weight: bold;');
				} else if (header.startsWith('CSeq:')) {
					console.log('%c' + header, 'color: #0066ff;');
				} else if (header.startsWith('Via:')) {
					console.log('%c' + header, 'color: #666666;');
				} else if (header.startsWith('Content-Type:')) {
					console.log('%c' + header, 'color: #cc6600; font-weight: bold;');
				} else {
					console.log(header);
				}
			}
			console.groupEnd();
			headersPrinted = true;

			// Extract and log SDP body if present
			if (bodyStartIndex < lines.length - 1) {
				console.group('Message Body:');
				const bodyLines = lines.slice(bodyStartIndex + 1);

				// Check if this is an SDP body
				if (bodyLines.some(line => line.startsWith('v=') || line.startsWith('o=') || line.startsWith('s='))) {
					console.log('%cSDP Body:', 'font-weight: bold; color: green;');

					// Group SDP sections
					let currentSection = null;
					bodyLines.forEach(line => {
						if (line.startsWith('m=')) {
							if (currentSection) console.groupEnd();
							currentSection = line.substring(2, line.indexOf(' ', 2));
							console.group(`Media Section (${currentSection}):`);
							console.log(line);
						} else if (line.startsWith('a=') && line.includes('rtpmap')) {
							console.log('%c' + line, 'color: #cc3300;');
						} else if (line.startsWith('a=') && line.includes('candidate')) {
							console.log('%c' + line, 'color: #009933;');
						} else if (line.startsWith('c=')) {
							console.log('%c' + line, 'color: #3366cc;');
						} else {
							console.log(line);
						}
					});

					if (currentSection) console.groupEnd();
				} else {
					// Not SDP, just print the body
					console.log(bodyLines.join('\n'));
				}

				console.groupEnd();
			}
		}

		if (!headersPrinted) {
			// Simplified fallback if our parsing fails
			console.log(message);
		}
	} catch (e) {
		// Fallback to raw message if parsing fails
		console.warn('Error parsing SIP message:', e);
		console.log(message);
	}

	console.groupEnd();
};

export const logSipEvent = (eventName, data) => {
	console.group(`SIP EVENT: ${eventName}`);
	console.log('Event data:', data);
	console.groupEnd();
};